import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { SecurityService } from '@/core/services/security/security.service';

export const errorInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const security: SecurityService = inject(SecurityService);
    const msgService = inject(MessageService);
    return next(request).pipe(
        tap({
            error: (error: HttpErrorResponse) => {
                switch (error.status) {
                    case 401:
                        security.logout();
                        break;
                    default:
                        msgService.add({
                            severity: 'error',
                            summary: error.statusText,
                            detail: error.error?.message ?? error.message
                        });
                        break;
                }
            }
        })
    );
};
